/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
import {EnhancedAuditEvent} from '../../ConfigurationList'
import {BuildMessage} from '../areaContracts'

export const buildSyncProfileMessage: BuildMessage = async (auditEvent: EnhancedAuditEvent, {}) => {
  return auditEvent.payload?.message
}
